import { render, staticRenderFns } from "./PerformanceBlockingChart.vue?vue&type=template&id=742fd1ce&scoped=true"
import script from "./PerformanceBlockingChart.vue?vue&type=script&lang=js"
export * from "./PerformanceBlockingChart.vue?vue&type=script&lang=js"
import style0 from "./PerformanceBlockingChart.vue?vue&type=style&index=0&id=742fd1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742fd1ce",
  null
  
)

export default component.exports